import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import ProductLabelTemplate from '@square/dashboard-items-data/models/squareup/inventory/v3/product-label-template';
import ProductInfoForLabels from '@square/dashboard-items-data/models/squareup/inventory/v3/product-info-for-labels';
import ProductLabelConfiguration from '@square/dashboard-items-data/models/squareup/inventory/v3/product-label-configuration';
export default ProtoBaseModel.extend({
  template: attr(ProductLabelTemplate),
  configuration: attr(ProductLabelConfiguration),
  products: repeated(ProductInfoForLabels),
  unitToken: attr(String)
});